import { render, staticRenderFns } from "./RegisterPatient.vue?vue&type=template&id=0d91e7fa&"
import script from "./RegisterPatient.vue?vue&type=script&lang=js&"
export * from "./RegisterPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports